export default __webpack_public_path__ + "static/media/raspberry-pi.92b5a56a.svg";